export const defaultSpeedCarUserInformationsState = {
  person_id: '',
  first_name: '',
  surname: '',
  contractor_head: '',
  contractor_service: ''
};
